import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import AccountSettingsService from '../../services/account-settings.service';
import { Spinner, Alert } from '../../services/notiflix.service';
import { CloseButtonSvgIcon, CloseEye, OpenEye } from './IconProvider';
import { useTranslation } from 'react-i18next';
const ChangePassword = ({ setChangePasswordPop }) => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const { t } = useTranslation(['auth', 'common']);
  const schema = Yup.object({
    oldPassword: Yup.string().required(t('old_password_required')),
    password: Yup.string()
      .required(t('new_password_required'))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9\s]).{8,}$/,
        t('password_requirements'),
      ),
    confirmPassword: Yup.string()
      .required(t('confirm_password_required'))
      .oneOf([Yup.ref('password'), null], t('passwords_must_match')),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onChangePassword = async (_input) => {
    try {
      Spinner.show();
      const _forgotPasswordData = {
        old_password: _input.oldPassword,
        new_password: _input.password,
        confirm_password: _input.confirmPassword,
      };

      let response =
        await AccountSettingsService.changePassword(_forgotPasswordData);
      if (response.status === 'failure') {
        Spinner.hide();
        Alert.error(response.message);
        return false;
      }

      Spinner.hide();
      reset();
      setChangePasswordPop(false);
      Alert.success(response.message);
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full mx-3 my-4 max-w-md rounded-lg overflow-hidden">
          {/*content*/}
          <div className="border-0  shadow-lg relative flex flex-col w-full bg-white dark:bg-slate-800  dark:text-slate-200 outline-none focus:outline-none">
            {/*header*/}
            <div className="flex justify-between items-center py-3 px-6  border-2">
              <h3>{t('common:change_password')}</h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
                onClick={() => setChangePasswordPop(false)}
              >
                <span className="bg-transparent text-black w-10 dark:bg-slate-400 dark:rounded-md block outline-none focus:outline-none">
                  <CloseButtonSvgIcon />
                </span>
              </button>
            </div>
            {/*body*/}
            <form onSubmit={handleSubmit(onChangePassword)}>
              <div className="relative p-6 flex-auto">
                <div className="relative mb-2 mt-4">
                  <input
                    placeholder={t('old_password')}
                    name="oldPassword"
                    type="password"
                    {...register('oldPassword', { required: true })}
                    className="mb-1"
                  />
                  <div className="common-error-text">
                    {errors.oldPassword?.message}
                  </div>
                </div>
                <div className="relative mb-2 mt-4">
                  <input
                    placeholder={t('new_password')}
                    name="password"
                    {...register('password', { required: true })}
                    className="mb-1 dark:text-gray-900"
                    type={passwordShown ? 'text' : 'password'}
                  />
                  <Link
                    to=""
                    onClick={() =>
                      setPasswordShown(passwordShown ? false : true)
                    }
                  >
                    <div className="position-align-item">
                      {passwordShown ? <CloseEye /> : <OpenEye />}
                    </div>
                  </Link>
                  <div className="common-error-text">
                    {errors.password?.message}
                  </div>
                </div>
                <div className="relative mb-2 mt-4">
                  <input
                    placeholder={t('confirm_password')}
                    name="password"
                    className="mb-1 dark:text-gray-900"
                    type={confirmPasswordShown ? 'text' : 'password'}
                    {...register('confirmPassword', { required: true })}
                  />
                  <Link
                    to=""
                    onClick={() =>
                      setConfirmPasswordShown(
                        confirmPasswordShown ? false : true,
                      )
                    }
                  >
                    <div className="position-align-item">
                      {confirmPasswordShown ? <CloseEye /> : <OpenEye />}
                    </div>
                  </Link>
                  <div className="common-error-text">
                    {errors.confirmPassword?.message}
                  </div>
                </div>
              </div>

              {/*footer*/}
              <div className=" pt-2 pb-4 px-6 text-center flex flex-col gap-2 justify-between">
                <button
                  className="bg-GreenColor active:bg-[#92C24B] w-full text-brandBlue border border-GreenColor font-bold uppercase text-sm px-6 py-3 rounded-lg  inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                  type="submit"
                >
                  {t('common:change_password')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default ChangePassword;
